import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { Transformation } from "@/components/home/Transformation";
import { Metier, Steps, Stats, ClosingCTA, PartnerBand, QuickAccess } from "@/components/home/Sections";
import { FeaturedProjects, EcosystemBanner, LatestArticles } from "@/components/home/Dynamic";
import { LifeMatchTeaser } from "@/components/home/LifeMatchTeaser";
import { AssistantHomeBanner } from "@/components/AssistantChat";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo page="home" />
      <Hero />
      <QuickAccess />
      <Transformation />
      <Metier />
      <PartnerBand />
      <Steps />
      <Stats />
      <LifeMatchTeaser />
      <FeaturedProjects />
      <EcosystemBanner />
      <LatestArticles />
      <AssistantHomeBanner />
      <ClosingCTA />
    </div>
  );
}
